import { Chip, Theme, Typography, createStyles, makeStyles } from '@forgeglobal/design-framework'
import { getHumanReadableSource } from 'util/AccountUtils'
import React from 'react'
import moment from 'moment'

interface OpportunityFormCardFooterProps {
  createdAt: string
  source: string
  creatorName: string
}

const useStyles = makeStyles(({ palette, spacing }: Theme) =>
  createStyles({
    footerContainer: {
      display: 'flex',
      justifyContent: 'left',
      borderTop: `1px solid ${palette.divider}`,
      paddingTop: spacing(2),
      width: '100%',
    },
  })
)

export const OpportunityFormCardFooter: React.FC<OpportunityFormCardFooterProps> = ({
  source,
  createdAt,
  creatorName,
}) => {
  const classes = useStyles()
  return (
    <div className={classes.footerContainer}>
      <Typography variant="subtitle2" fontWeight="light">
        Created via
        <Chip label={getHumanReadableSource(source)} color={source === 'crm_admin' ? 'primary' : undefined} />
        by
        <Chip label={creatorName} />
        on {moment(createdAt).format('MM/DD/YYYY')} at {moment(createdAt).format('hh:mm A')}
      </Typography>
    </div>
  )
}
